package empiresmp.feature.shop.backend.model

enum class ShopItemType {
    ITEM_STACK,
    COMMAND,
    PERMISSION,
    MONEY,
    JUST_DONATE,
    UNBAN
}
